import React, { FC, useMemo } from "react";
import { Field } from "react-final-form";
import { makeStyles, Typography } from "@material-ui/core";
import { getData } from "country-list";
import Autocomplete from "../../../../../../components/Autocomplete";
import Exams from "../../../components/step2/Exams";
import { IStepTemplate } from "../../../types";

const useStyles = makeStyles(() => ({
  label: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#535358",
    marginTop: 6,
    marginBottom: 14,
  },
  restrictions: {
    marginBottom: 24,
  },
}));

const Template: FC<IStepTemplate> = ({ stepName }) => {
  const classes = useStyles();
  const countries = useMemo(
    () =>
      getData().sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
      ),
    [],
  );

  return (
    <>
      <Exams
        stepName={stepName}
        required={true}
        infoIcon="Minimum 2 exams should be indicated. You can also add those which are available."
      />
      <div>
        <Typography className={classes.label}>Restrictions</Typography>
        <Field
          fullWidth
          type="text"
          label="Restricted Countries"
          options={countries}
          placeholder="Please Select"
          infoIcon="Choose the countries from which you will not accept students"
          component={Autocomplete}
          multiple={true}
          disableCloseOnSelect={true}
          name={`${stepName}.restrictedCountries`}
          className={classes.restrictions}
        />
      </div>
    </>
  );
};

export default Template;
